export default "__VITE_ASSET__kY3hsy6U__"